'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$resource',
                function($resource) {
                    return $resource('api/staffs/:staffId', null, {
                        get: {method: 'GET'},
                        create: {method: 'POST'},
                        update: {method: 'PUT'},
                        remove: {method: 'DELETE'},
                        exists: {url: 'api/staffs/exists', method: 'GET'},
                        getAvailableProjectManagersOfCurrentUser: {
                            url: 'api/staffs/available-project-managers-of-current-user',
                            method: 'GET',
                        },
                    });
                }];
